<template>
	<v-layout row justify-center>
		<v-snackbar top v-bind="mergedOptions" auto-height>
			{{ mergedOptions.message }}
			<v-btn dark flat class="pr-0" @click.prevent="mergedOptions.value = false">
				<v-icon>close</v-icon>
			</v-btn>
		</v-snackbar>
	</v-layout>
</template>

<script>
	export default {
		props: {
			options: {
				required: true
			}
		},

		data() {
			return {
				mergedOptions: {}
			};
		},

		watch: {
			options: {
				handler() {
					let defaultOptions = {
						message: null,
						timeout: 5000,
						color: 'success',
						vertical: this.$vuetify.breakpoint.smAndDown,
						value: false
					};

					this.mergedOptions = Object.assign({}, defaultOptions, this.options);

					this.mergedOptions.value = true;

					if (this.mergedOptions.timeout > 0) {
						setTimeout(() => (this.mergedOptions.value = false), this.mergedOptions.timeout);
					}
				}
			}
		}
	};
</script>